var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMostTradedRisk = function SvgMostTradedRisk(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 28.4374H31.5625C31.7344 28.4374 31.875 28.2967 31.875 28.1249V11.0936C31.875 10.8124 31.5352 10.6756 31.3398 10.871L23.125 19.0858L18.2266 14.242C18.1678 14.1839 18.0885 14.1513 18.0059 14.1513C17.9232 14.1513 17.8439 14.1839 17.7852 14.242L10.4023 21.6483C10.3737 21.677 10.351 21.7111 10.3356 21.7487C10.3201 21.7862 10.3123 21.8265 10.3125 21.867V28.1249C10.3125 28.2967 10.4531 28.4374 10.625 28.4374Z",
    fill: "#14B8A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6875 30.9375H7.8125V6.5625C7.8125 6.39062 7.67188 6.25 7.5 6.25H5.3125C5.14062 6.25 5 6.39062 5 6.5625V33.4375C5 33.6094 5.14062 33.75 5.3125 33.75H34.6875C34.8594 33.75 35 33.6094 35 33.4375V31.25C35 31.0781 34.8594 30.9375 34.6875 30.9375Z",
    fill: "#14B8A6"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMostTradedRisk, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/most-traded-risk.a3d68023.svg";
export { ForwardRef as ReactComponent };